import { isServer, QueryClient } from '@tanstack/react-query';

function makeQueryClient() {
  return new QueryClient();
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (isServer) {
    /**
     * Server: always make a new query client
     * This ensures that data is not shared between different users and requests.
     */
    return makeQueryClient();
  }
  /**
   * Browser: make a new query client if we don't already have one
   * This is very important, so we don't re-make a new client if React
   * suspends during the initial render. This may not be needed if we
   * have a suspense boundary below the creation of the query client
   */
  if (!browserQueryClient) browserQueryClient = makeQueryClient();
  return browserQueryClient;
}
